import {
  AED,
  AFN,
  ALL,
  AMD,
  AOA,
  ARS,
  AUD,
  AWG,
  AZN,
  BAM,
  BBD,
  BDT,
  BGN,
  BHD,
  BIF,
  BMD,
  BND,
  BOB,
  BOV,
  BRL,
  BSD,
  BTN,
  BWP,
  BYN,
  BZD,
  CAD,
  CDF,
  CHE,
  CHF,
  CHW,
  CLF,
  CLP,
  CNY,
  COP,
  COU,
  CRC,
  CUP,
  CVE,
  CZK,
  DJF,
  DKK,
  DOP,
  DZD,
  EGP,
  ERN,
  ETB,
  EUR,
  FJD,
  FKP,
  GBP,
  GEL,
  GHS,
  GIP,
  GMD,
  GNF,
  GTQ,
  GYD,
  HKD,
  HNL,
  HTG,
  HUF,
  IDR,
  ILS,
  INR,
  IQD,
  IRR,
  ISK,
  JMD,
  JOD,
  JPY,
  KES,
  KGS,
  KHR,
  KMF,
  KPW,
  KRW,
  KWD,
  KYD,
  KZT,
  LAK,
  LBP,
  LKR,
  LRD,
  LSL,
  LYD,
  MAD,
  MDL,
  MGA,
  MKD,
  MMK,
  MNT,
  MOP,
  MRU,
  MUR,
  MVR,
  MWK,
  MXN,
  MXV,
  MYR,
  MZN,
  NAD,
  NGN,
  NIO,
  NOK,
  NPR,
  NZD,
  OMR,
  PAB,
  PEN,
  PGK,
  PHP,
  PKR,
  PLN,
  PYG,
  QAR,
  RON,
  RSD,
  RUB,
  RWF,
  SAR,
  SBD,
  SCR,
  SDG,
  SEK,
  SGD,
  SHP,
  SLE,
  SOS,
  SRD,
  SSP,
  STN,
  SVC,
  SYP,
  SZL,
  THB,
  TJS,
  TMT,
  TND,
  TOP,
  TRY,
  TTD,
  TWD,
  TZS,
  UAH,
  UGX,
  USD,
  USN,
  UYI,
  UYU,
  UYW,
  UZS,
  VED,
  VES,
  VND,
  VUV,
  WST,
  XAD,
  XAF,
  XCD,
  XCG,
  XOF,
  XPF,
  YER,
  ZAR,
  ZMW,
  ZWG,
} from 'dinero.js';

export const dineroCurrencyMapping = {
  AED: AED,
  AFN: AFN,
  ALL: ALL,
  AMD: AMD,
  AOA: AOA,
  ARS: ARS,
  AUD: AUD,
  AWG: AWG,
  AZN: AZN,
  BAM: BAM,
  BBD: BBD,
  BDT: BDT,
  BGN: BGN,
  BHD: BHD,
  BIF: BIF,
  BMD: BMD,
  BND: BND,
  BOB: BOB,
  BOV: BOV,
  BRL: BRL,
  BSD: BSD,
  BTN: BTN,
  BWP: BWP,
  BYN: BYN,
  BZD: BZD,
  CAD: CAD,
  CDF: CDF,
  CHE: CHE,
  CHF: CHF,
  CHW: CHW,
  CLF: CLF,
  CLP: CLP,
  CNY: CNY,
  COP: COP,
  COU: COU,
  CRC: CRC,
  CUP: CUP,
  CVE: CVE,
  CZK: CZK,
  DJF: DJF,
  DKK: DKK,
  DOP: DOP,
  DZD: DZD,
  EGP: EGP,
  ERN: ERN,
  ETB: ETB,
  EUR: EUR,
  FJD: FJD,
  FKP: FKP,
  GBP: GBP,
  GEL: GEL,
  GHS: GHS,
  GIP: GIP,
  GMD: GMD,
  GNF: GNF,
  GTQ: GTQ,
  GYD: GYD,
  HKD: HKD,
  HNL: HNL,
  HTG: HTG,
  HUF: HUF,
  IDR: IDR,
  ILS: ILS,
  INR: INR,
  IQD: IQD,
  IRR: IRR,
  ISK: ISK,
  JMD: JMD,
  JOD: JOD,
  JPY: JPY,
  KES: KES,
  KGS: KGS,
  KHR: KHR,
  KMF: KMF,
  KPW: KPW,
  KRW: KRW,
  KWD: KWD,
  KYD: KYD,
  KZT: KZT,
  LAK: LAK,
  LBP: LBP,
  LKR: LKR,
  LRD: LRD,
  LSL: LSL,
  LYD: LYD,
  MAD: MAD,
  MDL: MDL,
  MGA: MGA,
  MKD: MKD,
  MMK: MMK,
  MNT: MNT,
  MOP: MOP,
  MRU: MRU,
  MUR: MUR,
  MVR: MVR,
  MWK: MWK,
  MXN: MXN,
  MXV: MXV,
  MYR: MYR,
  MZN: MZN,
  NAD: NAD,
  NGN: NGN,
  NIO: NIO,
  NOK: NOK,
  NPR: NPR,
  NZD: NZD,
  OMR: OMR,
  PAB: PAB,
  PEN: PEN,
  PGK: PGK,
  PHP: PHP,
  PKR: PKR,
  PLN: PLN,
  PYG: PYG,
  QAR: QAR,
  RON: RON,
  RSD: RSD,
  RUB: RUB,
  RWF: RWF,
  SAR: SAR,
  SBD: SBD,
  SCR: SCR,
  SDG: SDG,
  SEK: SEK,
  SGD: SGD,
  SHP: SHP,
  SLE: SLE,
  SOS: SOS,
  SRD: SRD,
  SSP: SSP,
  STN: STN,
  SVC: SVC,
  SYP: SYP,
  SZL: SZL,
  THB: THB,
  TJS: TJS,
  TMT: TMT,
  TND: TND,
  TOP: TOP,
  TRY: TRY,
  TTD: TTD,
  TWD: TWD,
  TZS: TZS,
  UAH: UAH,
  UGX: UGX,
  USD: USD,
  USN: USN,
  UYI: UYI,
  UYU: UYU,
  UYW: UYW,
  UZS: UZS,
  VED: VED,
  VES: VES,
  VND: VND,
  VUV: VUV,
  WST: WST,
  XAD: XAD,
  XAF: XAF,
  XCD: XCD,
  XCG: XCG,
  XOF: XOF,
  XPF: XPF,
  YER: YER,
  ZAR: ZAR,
  ZMW: ZMW,
  ZWG: ZWG,
};

export const currencyToCountryMapping = {
  AED: 'AE',
  AFN: 'AF',
  ALL: 'AL',
  AMD: 'AM',
  AOA: 'AO',
  ARS: 'AR',
  AUD: 'AU',
  AWG: 'AW',
  AZN: 'AZ',
  BAM: 'BA',
  BBD: 'BB',
  BDT: 'BD',
  BGN: 'BG',
  BHD: 'BH',
  BIF: 'BI',
  BMD: 'BM',
  BND: 'BN',
  BOB: 'BO',
  BOV: 'BO',
  BRL: 'BR',
  BSD: 'BS',
  BTN: 'BT',
  BWP: 'BW',
  BYN: 'BY',
  BZD: 'BZ',
  CAD: 'CA',
  CDF: 'CD',
  CHE: 'CH',
  CHF: 'CH',
  CHW: 'CH',
  CLF: 'CL',
  CLP: 'CL',
  CNY: 'CN',
  COP: 'CO',
  COU: 'CO',
  CRC: 'CR',
  CUP: 'CU',
  CVE: 'CV',
  CZK: 'CZ',
  DJF: 'DJ',
  DKK: 'DK',
  DOP: 'DO',
  DZD: 'DZ',
  EGP: 'EG',
  ERN: 'ER',
  ETB: 'ET',
  EUR: 'EU',
  FJD: 'FJ',
  FKP: 'FK',
  GBP: 'GB',
  GEL: 'GE',
  GHS: 'GH',
  GIP: 'GI',
  GMD: 'GM',
  GNF: 'GN',
  GTQ: 'GT',
  GYD: 'GY',
  HKD: 'HK',
  HNL: 'HN',
  HTG: 'HT',
  HUF: 'HU',
  IDR: 'ID',
  ILS: 'IL',
  INR: 'IN',
  IQD: 'IQ',
  IRR: 'IR',
  ISK: 'IS',
  JMD: 'JM',
  JOD: 'JO',
  JPY: 'JP',
  KES: 'KE',
  KGS: 'KG',
  KHR: 'KH',
  KMF: 'KM',
  KPW: 'KP',
  KRW: 'KR',
  KWD: 'KW',
  KYD: 'KY',
  KZT: 'KZ',
  LAK: 'LA',
  LBP: 'LB',
  LKR: 'LK',
  LRD: 'LR',
  LSL: 'LS',
  LYD: 'LY',
  MAD: 'MA',
  MDL: 'MD',
  MGA: 'MG',
  MKD: 'MK',
  MMK: 'MM',
  MNT: 'MN',
  MOP: 'MO',
  MRU: 'MR',
  MUR: 'MU',
  MVR: 'MV',
  MWK: 'MW',
  MXN: 'MX',
  MXV: 'MX',
  MYR: 'MY',
  MZN: 'MZ',
  NAD: 'NA',
  NGN: 'NG',
  NIO: 'NI',
  NOK: 'NO',
  NPR: 'NP',
  NZD: 'NZ',
  OMR: 'OM',
  PAB: 'PA',
  PEN: 'PE',
  PGK: 'PG',
  PHP: 'PH',
  PKR: 'PK',
  PLN: 'PL',
  PYG: 'PY',
  QAR: 'QA',
  RON: 'RO',
  RSD: 'RS',
  RUB: 'RU',
  RWF: 'RW',
  SAR: 'SA',
  SBD: 'SB',
  SCR: 'SC',
  SDG: 'SD',
  SEK: 'SE',
  SGD: 'SG',
  SHP: 'SH',
  SLE: 'SL',
  SOS: 'SO',
  SRD: 'SR',
  SSP: 'SS',
  STN: 'ST',
  SVC: 'SV',
  SYP: 'SY',
  SZL: 'SZ',
  THB: 'TH',
  TJS: 'TJ',
  TMT: 'TM',
  TND: 'TN',
  TOP: 'TO',
  TRY: 'TR',
  TTD: 'TT',
  TWD: 'TW',
  TZS: 'TZ',
  UAH: 'UA',
  UGX: 'UG',
  USD: 'US',
  USN: 'US',
  UYI: 'UY',
  UYU: 'UY',
  UYW: 'UY',
  UZS: 'UZ',
  VED: 'VE',
  VES: 'VE',
  VND: 'VN',
  VUV: 'VU',
  WST: 'WS',
  XAD: 'EU',
  XAF: 'XA',
  XCD: 'XC',
  XCG: 'CW',
  XOF: 'XO',
  XPF: 'XP',
  YER: 'YE',
  ZAR: 'ZA',
  ZMW: 'ZM',
  ZWG: 'ZW',
};
